import React, { Component } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import {changeAmount} from "../../actions";

class AmountForm extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleIncrease = this.handleIncrease.bind(this);
    this.handleDecrease = this.handleDecrease.bind(this);
  }

  handleChange(size) {
    return (e) => {
      this.props.changeAmount(size.id, e.target.value);
    }
  }

  handleIncrease(size) {
    return () => {
      const value = this.props.products.amount[size.id] + 1;
      this.props.changeAmount(size.id, (value));
    }
  }

  handleDecrease(size) {
    return () => {
      const value = Math.max(0, this.props.products.amount[size.id] - 1);
      this.props.changeAmount(size.id, (value));
    }
  }

  render() {
    return (
      <div className="t-container-amount-form">
        {this.props.products.sizes.map((size) => {
          return (
            <div key={size.id} className="t-container-amount-form-item">
              <div><label>{size.symbol}</label></div>
              <button className="btn btn-block" onClick={this.handleIncrease(size)}><FontAwesomeIcon icon={faChevronUp} /></button>
              <input type="text" className="form-control" value={this.props.products.amount[size.id] || ''} onChange={this.handleChange(size)} />
              <button className="btn btn-block" onClick={this.handleDecrease(size)}><FontAwesomeIcon icon={faChevronDown} /></button>
            </div>
          );
        })}
      </div>
    );
  }
}

export default connect(f => f, {changeAmount})(AmountForm);


// WEBPACK FOOTER //
// ./src/components/Navbar/AmountForm.js